<template>
  <div>
    <q-card class="my-card  bg-deep-purple-1">
      <q-card-section>
        <apexchart ref="graph" type=line height=350 :options="chartOptions" :series="charSeriesData"/>
        <q-inner-loading :showing="$apollo.loading">
          <q-spinner-dots size="50px" color="primary"/>

        </q-inner-loading>
      </q-card-section>

      <!-- <q-card-actions>
         <q-btn flat>Action 1</q-btn>
         <q-btn flat>Action 2</q-btn>
       </q-card-actions>-->
    </q-card>

  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

import { GRAPH1 } from '../graphql/graphql'
import { numberToReal } from '../helpers'

export default {
  name: 'GeneralChart',
  components: {
    apexchart: VueApexCharts
  },
  data () {
    return {
      stroke: {
        curve: 'smooth'
      },
      graphs: [],
      result: [],
      charSeriesData: [],
      chartOptions: {
        colors: ['#F44336', '#3f51b5', '#9C27B0', '#f9a3a4', '#4ecdc4', '#03a9f4', '#A5978B', '#2E294E', '#ec6028'],
        tooltip: {
          y: {
            formatter: function (val) {
              return numberToReal(val)
            }
          }
        },
        chart: {
          stroke: {
            curve: 'smooth'
          },
          shadow: {
            enabled: true,
            color: '#000',
            top: 18,
            left: 7,
            blur: 10,
            opacity: 1
          },
          toolbar: {
            show: true,
            tools: {
              download: true
            }
          }
        },
        /*  colors: ['#77B6EA', '#545454', '#F94840'], */
        dataLabels: {
          enabled: true,
          formatter: function (value) {
            return numberToReal(value)
          }
        },
        stroke: {
          curve: 'smooth'
        },
        curve: 'smooth'
      },
      title: {
        text: 'Histórico de doações',
        style: {
          fontSize: '30px',
          color: '#263238'
        },
        align: 'left'
      },
      grid: {
        borderColor: '#e7e7e7',
        row: {
          colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
          opacity: 0.5
        }
      },
      markers: {
        size: 6
      },
      xaxis: {},
      legend: {
        position: 'top',
        horizontalAlign: 'right',
        floating: true,
        offsetY: -25,
        offsetX: -5
      }
    }
  },
  apollo: {
    graphs: {
      query: GRAPH1,
      // pollInterval: 3000,
      update (store, data) {
        this.chartOptions = { xaxis: { categories: [] } };
        this.chartOptions = { xaxis: { categories: store.graphs[0] } };
        this.charSeriesData.push({ name: 'Boleto', data: store.graphs[1] });
        this.charSeriesData.push({ name: 'Débito', data: store.graphs[2] });
        this.charSeriesData.push({ name: 'Crédito', data: store.graphs[3] });
        this.charSeriesData.push({ name: 'PayPal', data: store.graphs[4] });
        this.charSeriesData.push({ name: 'Transferência Identificada', data: store.graphs[5] });
        this.charSeriesData.push({ name: 'Transferência sem relacionamento', data: store.graphs[6] });
        this.charSeriesData.push({ name: 'Pólen', data: store.graphs[7] });
        this.charSeriesData.push({ name: 'Presente solidário', data: store.graphs[8] });
        this.charSeriesData.push({ name: 'Pix', data: store.graphs[9] });
      }
    }
  }
}
</script>
<style>
#chat-1,
.chartjs-size-monitor,
.chartjs-render-monitor {
  width: 100% !important;
  height: 50vh !important;
}
</style>
